/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The ExchangeRateData model module.
 * @module model/ExchangeRateData
 * @version 1.0
 */
class ExchangeRateData {
    /**
     * Constructs a new <code>ExchangeRateData</code>.
     * @alias module:model/ExchangeRateData
     */
    constructor() { 
        
        ExchangeRateData.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>ExchangeRateData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ExchangeRateData} obj Optional instance to populate.
     * @return {module:model/ExchangeRateData} The populated <code>ExchangeRateData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ExchangeRateData();

            if (data.hasOwnProperty('timestamp')) {
                obj['timestamp'] = ApiClient.convertToType(data['timestamp'], 'Date');
            }
            if (data.hasOwnProperty('perToUsdt')) {
                obj['perToUsdt'] = ApiClient.convertToType(data['perToUsdt'], 'Number');
            }
            if (data.hasOwnProperty('xperToUsdt')) {
                obj['xperToUsdt'] = ApiClient.convertToType(data['xperToUsdt'], 'Number');
            }
            if (data.hasOwnProperty('hvhToUsdt')) {
                obj['hvhToUsdt'] = ApiClient.convertToType(data['hvhToUsdt'], 'Number');
            }
            if (data.hasOwnProperty('arbToUsdt')) {
                obj['arbToUsdt'] = ApiClient.convertToType(data['arbToUsdt'], 'Number');
            }
            if (data.hasOwnProperty('hvhToPer')) {
                obj['hvhToPer'] = ApiClient.convertToType(data['hvhToPer'], 'Number');
            }
            if (data.hasOwnProperty('hvhToXper')) {
                obj['hvhToXper'] = ApiClient.convertToType(data['hvhToXper'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>ExchangeRateData</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>ExchangeRateData</code>.
     */
    static validateJSON(data) {

        return true;
    }


}



/**
 * @member {Date} timestamp
 */
ExchangeRateData.prototype['timestamp'] = undefined;

/**
 * @member {Number} perToUsdt
 */
ExchangeRateData.prototype['perToUsdt'] = undefined;

/**
 * @member {Number} xperToUsdt
 */
ExchangeRateData.prototype['xperToUsdt'] = undefined;

/**
 * @member {Number} hvhToUsdt
 */
ExchangeRateData.prototype['hvhToUsdt'] = undefined;

/**
 * @member {Number} arbToUsdt
 */
ExchangeRateData.prototype['arbToUsdt'] = undefined;

/**
 * @member {Number} hvhToPer
 */
ExchangeRateData.prototype['hvhToPer'] = undefined;

/**
 * @member {Number} hvhToXper
 */
ExchangeRateData.prototype['hvhToXper'] = undefined;






export default ExchangeRateData;

